module.exports = __webpack_public_path__ + "static/media/6.a692558b.jpg";